<template>
  <div class="RenderAuthUnread">
    <ClientOnly>
      <span
        v-if="RenderAuthUserInstance?.show_unread"
        class="rounded-full bg-red-600 text-white absolute right-0 top-0 flex items-center justify-center font-bold leading-none text-xs box-content"
        :class="[
          sidebarLayout
            ? 'w-1.5 h-1.5 -mr-0.5 -mt-1 border-2 border-white'
            : '-mr-1 w-3 h-3',
        ]"
        >{{ sidebarLayout ? '' : '!' }}</span
      >
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { useLoginComposable } from '~/modules/auth/composables/useLoginComposable'

const { RenderAuthUserInstance } = useLoginComposable()

defineProps({
  sidebarLayout: {
    type: Boolean,
    default: false,
  },
})
</script>
